import { motion } from "framer-motion";
import "./ContactMe.css";

export default function ContactMe() {
  return (
    <section id="Contact" className="contact-section">
      {/* Title Section */}
      <motion.div
        className="contact-header"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, ease: "easeOut" }}
      >
        <p className="sub-title">Get In Touch</p>
        <h2>Contact Me</h2>
        <p className="contact-text">
          Have a question or project in mind? I’m here to help! Whether it’s a
          collaboration, job opportunity, or just to say hello, I’d love to hear
          from you.
        </p>
      </motion.div>

      {/* Form Section */}
      <motion.form
        action="https://formsubmit.co/tahargriach@gmail.com"
        method="POST"
        className="contact-form"
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
      >
        <div className="form-grid">
          <label className="contact-label">
            <span>First Name</span>
            <input type="text" name="first-name" required />
          </label>

          <label className="contact-label">
            <span>Last Name</span>
            <input type="text" name="last-name" required />
          </label>

          <label className="contact-label">
            <span>Email</span>
            <input type="email" name="email" required />
          </label>

          <label className="contact-label">
            <span>Phone Number</span>
            <input type="tel" name="phone-number" required />
          </label>
        </div>

        <label className="contact-label">
          <span>Choose a Topic</span>
          <select name="topic" required>
            <option value="">Choose</option>
            <option value="Project Inquiry">Project Inquiry</option>
            <option value="Collaboration">Collaboration</option>
            <option value="General Question">General Question</option>
            <option value="Feedback">Feedback</option>
            <option value="Job Opportunity">Job Opportunity</option>
            <option value="Other">Other</option>
          </select>
        </label>

        <label className="contact-label">
          <span>Message</span>
          <textarea
            name="message"
            rows="7"
            placeholder="Type your message..."
            required
          ></textarea>
        </label>

        <motion.button
          type="submit"
          className="contact-btn"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Send Message
        </motion.button>
      </motion.form>
    </section>
  );
}
